import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { SupportedSeverityLabels } from 'src/app/models/tableColumns/supportedSeverityLabels.enum';

@Component({
  selector: 'app-severity-bars',
  templateUrl: './severity-bars.component.html',
  styleUrls: ['./severity-bars.component.scss'],
  standalone: true,
  imports: [NgClass],
})
export class SeverityBarsComponent {
  @Input() severity: SupportedSeverityLabels = SupportedSeverityLabels.low;

  readonly supportedSeverityLabels = SupportedSeverityLabels;
}
